import { render, staticRenderFns } from "./cart-item.vue?vue&type=template&id=b28ace60&scoped=true"
import script from "./cart-item.vue?vue&type=script&lang=js"
export * from "./cart-item.vue?vue&type=script&lang=js"
import style0 from "./cart-item.vue?vue&type=style&index=0&id=b28ace60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28ace60",
  null
  
)

export default component.exports